<mat-card>
  <mat-card-header>
    <mat-card-title
      cdkDrag
      cdkDragHandle
      cdkDragRootElement=".cdk-overlay-pane"
    >
      {{ title }}
    </mat-card-title>
  </mat-card-header>

  <!-- Form -->
  <mat-card-content style="margin: 2em 0; max-height: 70vh; overflow: auto">
    <form
      *ngIf="form"
      id="loginForm"
      [formGroup]="form"
      (ngSubmit)="onSubmit()"
    >
      <!-- Nombre Cliente  -->
      <mat-form-field>
        <mat-label>Nombre</mat-label>
        <input
          matInput
          placeholder="Nombre"
          formControlName="nombre"
          required
        />
      </mat-form-field>

      <!-- Logo  -->
      <mat-form-field [formGroupName]="'imagenes'">
        <mat-label>URL Logo</mat-label>
        <input matInput placeholder="https://logo.png" formControlName="logo" />
      </mat-form-field>

      <!-- Tipos de Dispositivos -->
      <mat-form-field>
        <mat-label>Tipo de Dispositivo</mat-label>
        <mat-select formControlName="tiposDispositivo" multiple>
          <mat-option *ngFor="let tipo of tipoDispositivos" [value]="tipo">
            {{ tipo }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Twilio -->
      <div
        [formGroup]="formTwilio"
        style="
          padding: 1em;
          border-radius: 8px;
          background-color: rgba(255, 255, 255, 0.1);
          margin-bottom: 1em;
        "
      >
        <h2>TWILIO</h2>
        <h4>➤ INFORMACIÓN PARA MENSAJES Y LLAMADAS:</h4>

        <div style="display: flex; flex-direction: row; gap: 1em">
          <!-- Accout SID -->
          <mat-form-field>
            <mat-label>Accout SID</mat-label>
            <input matInput placeholder="Accout SID" formControlName="accSid" />
          </mat-form-field>

          <!-- Auth Token -->
          <mat-form-field>
            <mat-label>Auth Token</mat-label>
            <input
              matInput
              placeholder="Auth Token"
              formControlName="authToken"
            />
          </mat-form-field>
        </div>

        <div style="display: flex; flex-direction: row; gap: 1em">
          <!-- Message Service SID -->
          <mat-form-field>
            <mat-label>Message Service SID</mat-label>
            <input
              matInput
              placeholder="Message Service SID"
              formControlName="msgServiceSid"
            />
          </mat-form-field>

          <!-- Número Llamadas -->
          <mat-form-field>
            <mat-label>Número Llamadas</mat-label>
            <input
              matInput
              placeholder="Número Llamadas"
              formControlName="phoneLlamada"
            />
          </mat-form-field>
        </div>

        <div style="display: flex; flex-direction: row; gap: 1em">
          <!-- Numero SMS -->
          <mat-form-field>
            <mat-label>Número SMS</mat-label>
            <input
              matInput
              placeholder="Número SMS"
              formControlName="phoneSms"
            />
          </mat-form-field>

          <!-- Numero Whatsapp -->
          <mat-form-field>
            <mat-label>Número WhatsApp</mat-label>
            <input
              matInput
              placeholder="Número WhatsApp"
              formControlName="phoneWhatsapp"
            />
          </mat-form-field>
        </div>

        <h4>➤ TEMPLATES SID WHATSAPP:</h4>

        <div [formGroup]="formTemplatesWhatsapp">
          <div style="display: flex; flex-direction: row; gap: 1em">
            <!-- Estado Bombeo -->
            <mat-form-field>
              <mat-label>Estado Bombeo</mat-label>
              <input
                matInput
                placeholder="Estado Bombeo"
                formControlName="Estado Bombeo"
              />
            </mat-form-field>

            <!-- Estado Bombeo -->
            <mat-form-field>
              <mat-label>Estado Bombeo Motivo</mat-label>
              <input
                matInput
                placeholder="Estado Bombeo Motivo"
                formControlName="Estado Bombeo Motivo"
              />
            </mat-form-field>
          </div>

          <div style="display: flex; flex-direction: row; gap: 1em">
            <!-- Corte de Energía -->
            <mat-form-field>
              <mat-label>Corte de Energía</mat-label>
              <input
                matInput
                placeholder="Corte de Energía"
                formControlName="Corte de Energía"
              />
            </mat-form-field>
          </div>
        </div>

        <h4>➤ DATOS DE REMITENTE DE MAIL:</h4>

        <div style="display: flex; flex-direction: row; gap: 1em">
          <!-- Email -->
          <mat-form-field>
            <mat-label>Email</mat-label>
            <input
              matInput
              placeholder="Dirección de Email"
              formControlName="senderEmail"
            />
          </mat-form-field>

          <!-- Nombre -->
          <mat-form-field>
            <mat-label>Nombre</mat-label>
            <input matInput placeholder="Nombre" formControlName="senderName" />
          </mat-form-field>
        </div>
        <div style="display: flex; flex-direction: row; gap: 1em">
          <!-- Dirección -->
          <mat-form-field>
            <mat-label>Dirección</mat-label>
            <input
              matInput
              placeholder="Dirección"
              formControlName="senderAddress"
            />
          </mat-form-field>

          <!-- Ciudad -->
          <mat-form-field>
            <mat-label>Ciudad</mat-label>
            <input matInput placeholder="Ciudad" formControlName="senderCity" />
          </mat-form-field>
        </div>
        <div style="display: flex; flex-direction: row; gap: 1em">
          <!-- Provincia/Departamento -->
          <mat-form-field>
            <mat-label>Provincia/Departamento</mat-label>
            <input
              matInput
              placeholder="Estado"
              formControlName="senderState"
            />
          </mat-form-field>

          <!-- Código Postal -->
          <mat-form-field>
            <mat-label>Código Postal</mat-label>
            <input
              matInput
              placeholder="Código Postal"
              formControlName="senderZip"
            />
          </mat-form-field>
        </div>

        <div style="display: flex; flex-direction: row; gap: 1em">
          <!-- Apikey SendGrid -->
          <mat-form-field>
            <mat-label>Apikey SendGrid</mat-label>
            <input
              matInput
              placeholder="Apikey SendGrid"
              formControlName="sendGridApiKey"
            />
          </mat-form-field>
        </div>

        <h4>➤ TEMPLATES SID EMAIL:</h4>

        <div [formGroup]="formTemplatesMail">
          <div style="display: flex; flex-direction: row; gap: 1em">
            <!-- Nuevo usuario -->
            <mat-form-field>
              <mat-label>Nuevo usuario</mat-label>
              <input
                matInput
                placeholder="Nuevo usuario"
                formControlName="Nuevo usuario"
              />
            </mat-form-field>

            <!-- Reset de contraseña -->
            <mat-form-field>
              <mat-label>Reset de contraseña</mat-label>
              <input
                matInput
                placeholder="Reset de contraseña"
                formControlName="Reset de contraseña"
              />
            </mat-form-field>
          </div>

          <div style="display: flex; flex-direction: row; gap: 1em">
            <!-- Cambio de contraseña -->
            <mat-form-field>
              <mat-label>Cambio de contraseña</mat-label>
              <input
                matInput
                placeholder="Cambio de contraseña"
                formControlName="Cambio de contraseña"
              />
            </mat-form-field>

            <!-- Reset de contraseña -->
            <!-- <mat-form-field>
              <mat-label>Reset de contraseña</mat-label>
              <input
                matInput
                placeholder="Reset de contraseña"
                formControlName="Reset de contraseña"
              />
            </mat-form-field> -->
          </div>
        </div>
      </div>

      <!-- INTEGRACIONES -->
      <div formArrayName="integraciones">
        <div
          *ngFor="
            let integracion of formArrayIntegraciones.controls;
            let i = index
          "
        >
          <div
            fxLayout="row"
            fxLayoutAlign="space-around center"
            fxLayoutGap="10px"
            [formGroupName]="i"
            style="
              border: 1px solid;
              padding: 0.5em;
              border-radius: 5px;
              margin-bottom: 0.5em;
            "
          >
            <ng-container>
              <div>
                <!-- Tipo Integracion -->
                <mat-form-field>
                  <mat-label>Tipo de Integración</mat-label>
                  <mat-select
                    formControlName="tipoIntegracion"
                    (selectionChange)="cambioTipoIntegracion(i)"
                  >
                    <mat-option
                      *ngFor="let tipo of tipoIntegraciones"
                      [value]="tipo"
                    >
                      {{ tipo }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <!-- Tipo Dispositivo -->
                <mat-form-field>
                  <mat-label>Tipo de Dispositivo</mat-label>
                  <mat-select formControlName="tipoDispositivo">
                    <mat-option
                      *ngFor="let tipo of tipoDispositivos"
                      [value]="tipo"
                    >
                      {{ tipo }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <!-- Endpoint  -->
                <mat-form-field
                  *ngIf="
                    formArrayIntegraciones.at(i).get('tipoIntegracion')
                      ?.value === 'HTTPS'
                  "
                >
                  <mat-label>Endpoint</mat-label>
                  <input
                    matInput
                    placeholder="https://miapi.com"
                    formControlName="endpoint"
                  />
                </mat-form-field>

                <!-- Metodo HTTP -->
                <mat-form-field
                  *ngIf="
                    formArrayIntegraciones.at(i).get('tipoIntegracion')
                      ?.value === 'HTTPS'
                  "
                >
                  <mat-label>Metodo HTTP</mat-label>
                  <mat-select formControlName="method">
                    <mat-option *ngFor="let tipo of metodosHttp" [value]="tipo">
                      {{ tipo }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <!-- Ubicacion Credenciales -->
                <mat-form-field
                  *ngIf="
                    formArrayIntegraciones.at(i).get('tipoIntegracion')
                      ?.value === 'HTTPS'
                  "
                >
                  <mat-label>Ubicacion Credenciales</mat-label>
                  <mat-select formControlName="ubicacionCredenciales">
                    <mat-option
                      *ngFor="let tipo of ubicacionesCredenciales"
                      [value]="tipo"
                    >
                      {{ tipo }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Credenciales 1 y 2 -->
              <div
                fxFlex="50"
                style="
                  background: #68656587;
                  padding: 0.5em;
                  border-radius: 5px;
                "
              >
                <!-- Credenciales -->
                <div
                  fxLayout="row wrap"
                  *ngIf="
                    (formArrayIntegraciones.at(i).get('tipoIntegracion')
                      ?.value === 'INFLUXV1' ||
                      formArrayIntegraciones.at(i).get('tipoIntegracion')
                        ?.value === 'INFLUXV2') &&
                    formCredenciales(i)
                  "
                  formGroupName="credenciales"
                >
                  <ng-container
                    *ngFor="let item of formCredenciales(i).controls | keyvalue"
                  >
                    <mat-form-field>
                      <mat-label> {{ item.key | titlecase }}</mat-label>
                      <input matInput [formControlName]="item.key" />
                    </mat-form-field>
                  </ng-container>
                </div>

                <!-- Credenciales 2 -->
                <div
                  fxLayout="row wrap"
                  *ngIf="
                    formArrayIntegraciones.at(i).get('tipoIntegracion')
                      ?.value === 'HTTPS' ||
                    formArrayIntegraciones.at(i).get('tipoIntegracion')
                      ?.value === 'MariaDB'
                  "
                  formArrayName="credenciales2"
                >
                  <div
                    *ngFor="
                      let integracion of formArrayCredenciales2(i).controls;
                      let j = index
                    "
                  >
                    <div
                      fxLayout="row"
                      fxLayoutAlign="space-around center"
                      fxLayoutGap="10px"
                      [formGroupName]="j"
                    >
                      <!-- KEY  -->
                      <mat-form-field>
                        <mat-label>KEY</mat-label>
                        <input
                          matInput
                          placeholder="username"
                          formControlName="key"
                        />
                      </mat-form-field>

                      <!-- VALUE  -->
                      <mat-form-field>
                        <mat-label>VALUE</mat-label>
                        <input
                          matInput
                          placeholder="admin"
                          formControlName="value"
                        />
                      </mat-form-field>

                      <!-- Boton Eliminar -->
                      <button
                        mat-mini-fab
                        color="warn"
                        matTooltip="Eliminar"
                        (click)="eliminarCredenciales2(i, j)"
                      >
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>

                  <!-- Agregar Integracion -->
                  <button
                    mat-raised-button
                    color="accent"
                    type="button"
                    (click)="agregarCredenciales2(i)"
                  >
                    Agregar Credencial
                  </button>
                </div>
              </div>
            </ng-container>
            <!-- Boton Eliminar -->
            <div fxLayoutAlign="center end">
              <button
                mat-mini-fab
                color="warn"
                matTooltip="Eliminar"
                (click)="eliminarIntegracion(i)"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Agregar Integracion -->
      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="agregarIntegracion()"
      >
        Agregar Integración
      </button>
    </form>
  </mat-card-content>

  <mat-divider></mat-divider>

  <!-- Botones -->
  <mat-card-actions fxLayoutGap="1em">
    <button
      mat-raised-button
      type="submit"
      form="loginForm"
      color="accent"
      fxFlex
      [disabled]="!form?.valid || loading"
    >
      GUARDAR
    </button>
    <button
      mat-raised-button
      type="button"
      form="loginForm"
      fxFlex
      (click)="close()"
    >
      Volver
    </button>
  </mat-card-actions>

  <p>{{ form?.errors }}</p>

  <!-- Progress Bar  -->
  <mat-card-footer>
    <mat-progress-bar
      [mode]="loading ? 'indeterminate' : 'determinate'"
    ></mat-progress-bar>
  </mat-card-footer>
</mat-card>
